import React from "react"

export const WaitingRoom = () => { 
    return(
        
            <svg height="62vh" width="100%" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.193 73.748h5.86v13.185h-5.86zM75.907 73.748h5.86v13.185h-5.86z"
                fill="#3a556a"
            />
            <path
                d="M35.052 52.746v18.07H17.53v-18.07c0-.981.385-1.877 1.013-2.536a3.668 3.668 0 0 1 2.686-1.163h10.13a3.693 3.693 0 0 1 3.692 3.7z"
                fill="#d15241"
            />
            <path
                d="M35.42 67.431a146.938 146.938 0 0 0-18.263-.002 2.022 2.022 0 0 0-1.885 2.022v.003c0 1.117.905 2.022 2.021 2.022h17.998a2.021 2.021 0 0 0 2.022-2.022 2.026 2.026 0 0 0-1.893-2.023z"
                fill="#ce412d"
            />
            <path
                d="M31.36 49.047H21.23c-1.06 0-2.019.448-2.686 1.163 1.02 4.602 4.578 14.403 16.508 16.272V52.746a3.693 3.693 0 0 0-3.691-3.699z"
                fill="#e56353"
            />
            <path
                d="M58.817 52.746v18.07h-17.52v-18.07c0-.981.384-1.877 1.012-2.536a3.668 3.668 0 0 1 2.686-1.163h10.13a3.693 3.693 0 0 1 3.692 3.7z"
                fill="#d15241"
            />
            <path
                d="M59.186 67.431a146.938 146.938 0 0 0-18.264-.002 2.022 2.022 0 0 0-1.885 2.022v.003c0 1.117.905 2.022 2.021 2.022h17.999a2.021 2.021 0 0 0 2.021-2.022 2.026 2.026 0 0 0-1.892-2.023z"
                fill="#ce412d"
            />
            <path
                d="M55.126 49.047H44.995c-1.06 0-2.018.448-2.686 1.163 1.021 4.602 4.579 14.403 16.508 16.272V52.746a3.693 3.693 0 0 0-3.691-3.699z"
                fill="#e56353"
            />
            <path
                d="M82.582 52.746v18.07h-17.52v-18.07c0-.981.384-1.877 1.012-2.536a3.668 3.668 0 0 1 2.686-1.163h10.131a3.693 3.693 0 0 1 3.691 3.7z"
                fill="#d15241"
            />
            <path
                d="M82.95 67.431a146.939 146.939 0 0 0-18.263-.002 2.022 2.022 0 0 0-1.885 2.022v.003c0 1.117.905 2.022 2.021 2.022h17.999a2.021 2.021 0 0 0 2.021-2.022 2.026 2.026 0 0 0-1.892-2.023z"
                fill="#ce412d"
            />
            <path
                d="M78.891 49.047h-10.13c-1.06 0-2.019.448-2.687 1.163 1.021 4.602 4.579 14.403 16.508 16.272V52.746a3.693 3.693 0 0 0-3.69-3.699z"
                fill="#e56353"
            />
            <path
                d="M86.088 63.89v7.586H13.912V63.89H11.04v8.804c0 1.212.982 2.194 2.195 2.194h73.528a2.195 2.195 0 0 0 2.195-2.194V63.89z"
                fill="#d5d6db"
            />
            <path
                d="M10.046 65.374c-.016.118-.024.236-.04.353a.876.876 0 0 0 .692.966 8 8 0 0 0 3.557 0 .876.876 0 0 0 .691-.966 24.48 24.48 0 0 1 0-5.968.884.884 0 0 0-.322-.793.857.857 0 0 0-.369-.18 8.236 8.236 0 0 0-3.557 0 .889.889 0 0 0-.691.973c.227 1.869.243 3.738.039 5.615z"
                fill="#3a556a"
            />
            <path
                d="M10.007 59.759a.889.889 0 0 1 .69-.974 8.236 8.236 0 0 1 3.558 0 .857.857 0 0 1 .37.18c-.252 1.336-1.234 4.972-4.58 6.409a24.413 24.413 0 0 0-.038-5.615z"
                fill="#64798a"
            />
            <path
                d="M89.954 65.374c.016.118.024.236.04.353a.876.876 0 0 1-.692.966 8 8 0 0 1-3.557 0 .876.876 0 0 1-.691-.966 24.479 24.479 0 0 0 0-5.968.884.884 0 0 1 .322-.793.857.857 0 0 1 .369-.18 8.236 8.236 0 0 1 3.557 0 .889.889 0 0 1 .691.973 24.413 24.413 0 0 0-.039 5.615z"
                fill="#3a556a"
            />
            <path
                d="M89.993 59.759a.889.889 0 0 0-.69-.974 8.236 8.236 0 0 0-3.558 0 .857.857 0 0 0-.37.18c.252 1.336 1.234 4.972 4.58 6.409a24.413 24.413 0 0 1 .038-5.615z"
                fill="#64798a"
            />
            <circle
                cx={50.563}
                cy={27.31}
                fill="#3a556a"
                transform="rotate(-45 50.561 27.322)"
                r={14.243}
            />
            <circle
                cx={50.563}
                cy={27.31}
                fill="#e6e9ef"
                transform="rotate(-45 50.561 27.322)"
                r={11.892}
            />
            <g fill="#3a556a">
                <path d="M50.302 16.517h.522v1.345h-.522zM50.302 36.759h.522v1.344h-.522zM61.356 27.048v.523h-1.344v-.523zM41.114 27.049v.523H39.77v-.523zM58.006 19.485l.37.37-.951.95-.37-.37zM43.696 33.798l.37.37-.95.95-.37-.37zM58.39 34.754l-.37.37-.95-.95.369-.37zM44.074 20.441l-.37.37-.95-.95.37-.37zM51.033 28.842h-.94l.167-8.37h.587z" />
                <path d="m55.936 27.717-6.708.26v-1.334l6.708.244z" />
            </g>
            <g fill="#d15241">
                <path d="m50.766 26.954.155.155-5.926 5.926-.155-.155z" />
                <circle cx={50.51} cy={27.369} r={0.27} />
            </g>
            </svg>
        
    )
}

export const DnaProp = () => { 
    return(
        <div>
            <svg
                height="70vh"
                viewBox="0 0 497 497"
                width="100%"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                d="M39.25 13.583v329.79c0 6.188 4.991 11.204 11.148 11.204h396.203c6.157 0 11.148-5.016 11.148-11.204V55.57c0-6.188-4.991-11.204-11.148-11.204H226.405V31.508C226.405 14.106 212.369 0 195.055 0H52.765C45.301 0 39.25 6.081 39.25 13.583z"
                fill="#edc472"
                />
                <path
                d="M196.405 31.508c0 7.101 5.757 12.858 12.858 12.858h17.142V31.508C226.405 14.106 212.369 0 195.055 0h-30c17.314 0 31.35 14.106 31.35 31.508zM446.602 44.366h-30c6.157 0 11.148 5.016 11.148 11.204v287.802c0 6.188-4.991 11.204-11.148 11.204h30c6.157 0 11.148-5.016 11.148-11.204V55.57c0-6.188-4.991-11.204-11.148-11.204z"
                fill="#dbb569"
                />
                <path
                d="M391.982 497H105.018c-5.991 0-10.848-4.857-10.848-10.848V87.244c0-5.991 4.857-10.847 10.848-10.847h286.964c5.991 0 10.848 4.857 10.848 10.847v398.909c0 5.99-4.857 10.847-10.848 10.847z"
                fill="#f7f8f4"
                />
                <path
                d="M391.982 76.396h-30c5.991 0 10.848 4.857 10.848 10.847v398.909c0 5.991-4.857 10.848-10.848 10.848h30c5.991 0 10.848-4.857 10.848-10.848V87.244c0-5.991-4.857-10.848-10.848-10.848z"
                fill="#eee"
                />
                <path
                d="M239.532 227.9h-95.471a4.125 4.125 0 0 1-4.125-4.125v-98.777a4.125 4.125 0 0 1 4.125-4.125h95.471a4.125 4.125 0 0 1 4.125 4.125v98.777a4.125 4.125 0 0 1-4.125 4.125z"
                fill="#ddebfd"
                />
                <path
                d="M230.645 227.9c-1.235-20.49-18.151-36.725-38.849-36.725-20.68 0-37.584 16.208-38.845 36.672"
                fill="#9ec8fc"
                />
                <ellipse cx={191.797} cy={175.39} fill="#ffcdbe" rx={17.152} ry={21.997} />
                <path
                d="M351.422 144.125h-69.008c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h69.008c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM351.422 184.892h-69.008c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h69.008c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM351.422 225.659h-69.008c-4.143 0-7.5-3.358-7.5-7.5s3.357-7.5 7.5-7.5h69.008c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM356.128 281.088H140.871a7.5 7.5 0 0 1 0-15h215.257c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM356.128 322.415H140.871a7.5 7.5 0 0 1 0-15h215.257c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM356.128 365.429H140.871a7.5 7.5 0 0 1 0-15h215.257c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM356.128 406.755H140.871a7.5 7.5 0 0 1 0-15h215.257c4.143 0 7.5 3.358 7.5 7.5s-3.357 7.5-7.5 7.5zM251.702 445.674H144.073a7.5 7.5 0 0 1 0-15h107.629a7.5 7.5 0 0 1 0 15z"
                fill="#ddebfd"
                />
            </svg>      
        </div>
    )
}

export const Pharmacy = () => {
    return(
        <div>
            <svg xmlns="http://www.w3.org/2000/svg"                 
                height="70vh"
                viewBox="0 0 497 497"
                width='100%'>
            <g fillRule="evenodd">
                <path
                d="M315.6 37.6c0 .22-.9.4-2 .4s-2 .18-2 .4c0 .22-.439.4-.976.4-.537 0-1.088.18-1.224.4-.136.22-.597.4-1.024.4-.427 0-.776.18-.776.4 0 .22-.36.4-.8.4-.44 0-.8.18-.8.4 0 .22-.36.4-.8.4-.44 0-.8.168-.8.373s-.315.477-.7.604c-1.201.396-6.491 5.236-6.497 5.945-.002.177-.542.897-1.201 1.6-.659.703-1.199 1.503-1.2 1.778-.001.275-.182.5-.402.5-.22 0-.4.36-.4.8 0 .44-.21.8-.467.8-.256 0-.363.104-.236.23.126.127.048.802-.175 1.5-.55 1.726-.719 5.17-.28 5.71.196.243.397.918.445 1.5.048.583.228 1.06.4 1.06.172 0 .313.26.313.578 0 .829 7.858 8.622 8.695 8.622.957 0 28.493 27.567 28.227 28.259-.264.687 6.99 7.741 7.961 7.741.394 0 .717.18.717.4 0 .243 1.8.4 4.6.4 2.53 0 4.6-.164 4.6-.365 0-.201.72-.486 1.6-.635.88-.149 1.6-.434 1.6-.635s.235-.365.522-.365c.287 0 1.18-.585 1.984-1.3.805-.715 2.279-2.02 3.277-2.9.998-.88 1.815-1.825 1.816-2.1.001-.275.181-.5.401-.5.22 0 .4-.198.4-.44 0-.241.54-.943 1.2-1.56.66-.617 1.2-1.409 1.2-1.76 0-.352.18-.64.4-.64.22 0 .4-.36.4-.8 0-.44.18-.8.4-.8.22 0 .4-.36.4-.8 0-.44.18-.8.4-.8.22 0 .4-.349.4-.776 0-.427.18-.888.4-1.024.22-.136.4-.672.4-1.19 0-.519.189-1.006.421-1.084.572-.19.569-12.063-.004-12.254-.229-.076-.417-.754-.417-1.505 0-.752-.18-1.367-.4-1.367-.22 0-.4-.36-.4-.8 0-.44-.18-.8-.4-.8-.22 0-.4-.236-.4-.525 0-.288-.36-.911-.8-1.383-.44-.472-.8-1.036-.8-1.253 0-.415-4.582-5.391-7.542-8.191-2.387-2.258-13.475-13.317-15.525-15.485-2.047-2.164-2.623-2.639-3.918-3.229-.558-.254-1.015-.614-1.015-.798 0-.185-.36-.336-.8-.336-.44 0-.8-.18-.8-.4 0-.22-.36-.4-.8-.4-.44 0-.8-.18-.8-.4 0-.22-.36-.4-.8-.4-.44 0-.8-.18-.8-.4 0-.22-.529-.4-1.176-.4-.647 0-1.288-.18-1.424-.4-.136-.22-.867-.4-1.624-.4-.757 0-1.376-.18-1.376-.4 0-.242-1.733-.4-4.4-.4-2.667 0-4.4.158-4.4.4"
                fill="#7c8c9c"
                />
                <path
                d="M300.889 73.9a80.798 80.798 0 0 1-2.911 2.5c-.943.77-3.871 3.515-6.507 6.1-2.635 2.585-4.948 4.7-5.139 4.7-.191 0-1.492 1.125-2.891 2.5-3.406 3.347-6.641 6.308-6.641 6.08 0-.102-1.762 1.571-3.916 3.717-3.961 3.947-4.148 4.103-4.908 4.103-.233 0-.312.18-.176.4.136.22.053.4-.185.4s-1.384.945-2.547 2.1c-1.164 1.155-2.865 2.75-3.78 3.545-.916.794-1.567 1.543-1.447 1.663.121.12-.154.337-.61.482-.456.145-2.651 2.051-4.878 4.237-2.227 2.185-4.171 3.973-4.32 3.973-.15 0-2.423 2.066-5.052 4.592-2.63 2.526-4.899 4.596-5.043 4.6-.144.004-2.169 1.885-4.5 4.18-2.331 2.294-4.243 4.049-4.25 3.9-.007-.15-.196.043-.42.428-.224.385-.603.7-.841.7-.239 0-.859.495-1.379 1.1l-.946 1.1 1.197.311c.658.171 16.487.261 35.176.2l33.979-.111.823-.883c.453-.486.823-.996.823-1.133 0-.138.9-1.155 2-2.26 1.1-1.106 2-2.185 2-2.399 0-.213.735-1.094 1.633-1.956.898-.863 1.5-1.569 1.338-1.569-.161 0 .122-.36.629-.8.507-.44.798-.8.645-.8-.318 0 .215-.676 2.055-2.608.715-.751 1.3-1.562 1.3-1.802 0-.241.18-.326.4-.19.22.136.4.039.4-.216s.54-.967 1.2-1.584c.66-.617 1.2-1.279 1.2-1.472 0-.193.36-.611.8-.928.44-.317.8-.722.8-.899 0-.177.81-1.132 1.8-2.122s1.8-1.966 1.8-2.169c0-.203.9-1.323 2-2.488 1.1-1.166 2-2.249 2-2.407 0-.158.54-.84 1.2-1.515.66-.675 1.2-1.309 1.2-1.409 0-.243 1.043-1.488 3.057-3.649 2.916-3.129 3.656-2.034-11.821-17.506-14.55-14.546-14.458-14.474-16.347-12.736"
                fill="#cbdbeb"
                />
                <path
                d="M2.701 142.143c-.824.472-1.499 1.005-1.5 1.186-.001.18-.297.624-.658.985-.815.815-.617 25.728.207 26.003.283.094.45 1.327.45 3.316 0 1.845.167 3.167.4 3.167.22 0 .4.9.4 2s.18 2 .4 2c.22 0 .4.889.4 1.976s.18 2.088.4 2.224c.22.136.4 1.137.4 2.224 0 1.087.18 1.976.4 1.976.22 0 .4.72.4 1.6 0 .88.18 1.6.4 1.6.22 0 .4.619.4 1.376 0 .757.18 1.488.4 1.624.22.136.4.777.4 1.424 0 .647.18 1.176.4 1.176.22 0 .4.619.4 1.376 0 .757.18 1.488.4 1.624.22.136.4.777.4 1.424 0 .647.18 1.176.4 1.176.22 0 .4.54.4 1.2 0 .66.17 1.2.377 1.2s.308.356.225.792c-.084.435.016.896.223 1.023.206.128.375.636.375 1.129s.143 1.067.318 1.276c.175.209.547 1.1.827 1.98.279.88.652 1.96.828 2.4.702 1.754 1.338 3.234 1.674 3.895.194.382.353.967.353 1.3 0 .333.18.605.4.605.22 0 .4.45.4 1s.135 1.001.3 1.003c.406.004 1.3 1.983 1.3 2.877 0 .396.18.72.4.72.22 0 .4.36.4.8 0 .44.18.8.4.8.22 0 .4.36.4.8 0 .44.18.8.4.8.22 0 .4.36.4.8 0 .44.18.8.4.8.22 0 .4.36.4.8 0 .44.18.8.4.8.22 0 .4.36.4.8 0 .44.18.8.4.8.22 0 .4.371.4.824 0 .453.18.712.4.576.22-.136.404.078.409.476.005.398.361 1.174.791 1.724.43.55.786 1.225.791 1.5.005.275.189.5.409.5.22 0 .4.36.4.8 0 .44.18.8.4.8.22 0 .4.27.4.6 0 .33.191.6.424.6.233 0 .312.18.176.4-.136.22-.046.4.2.4s.345.165.22.368c-.125.202.044.639.376.971.332.332.604.775.604.983 0 .209.266.601.59.87.325.269 1.083 1.461 1.684 2.649.601 1.187 1.236 2.159 1.41 2.159.174 0 .316.225.317.5 0 .275.54 1.13 1.199 1.9s1.199 1.585 1.199 1.812c.001.226.361.671.801.988.44.317.8.735.8.928 0 .193.54.855 1.2 1.472.66.617 1.2 1.337 1.2 1.6 0 .263.54.983 1.2 1.6.66.617 1.2 1.333 1.2 1.592 0 .259.675 1.133 1.5 1.942.825.809 1.979 2.165 2.564 3.014 3.183 4.612 19.568 20.971 22.733 22.696.65.354 1.066.759.926.9-.141.141-.047.256.21.256.256 0 1.208.72 2.115 1.6.907.88 1.815 1.6 2.018 1.6.204 0 .824.453 1.378 1.008.554.554 1.204.886 1.444.738.239-.148.332-.102.205.104-.127.205.835 1.153 2.138 2.107 1.303.954 2.369 1.894 2.369 2.089 0 .195.332.354.738.354.406 0 1.064.36 1.462.8.398.44.951.8 1.229.8.277 0 .564.138.638.306.073.169 1.483 1.11 3.133 2.093 1.65.982 3.238 2.014 3.529 2.293.29.279.875.508 1.3.508.424 0 .771.18.771.4 0 .22.371.4.824.4.453 0 .712.18.576.4-.136.22.033.4.376.4.343 0 .624.18.624.4 0 .22.371.4.824.4.453 0 .712.18.576.4-.136.22-.002.4.297.4.754 0 2.696.935 2.7 1.3.002.165.363.3.803.3.44 0 .8.18.8.4 0 .22.36.4.8.4.44 0 .8.18.8.4 0 .22.27.4.6.4.33 0 .6.18.6.4 0 .22.45.4 1 .4s1 .18 1 .4c0 .22.36.4.8.4.44 0 .8.18.8.4 0 .22.235.4.521.4 1.349 0 4.916 2.196 3.78 2.326-1.539.178-1.55.294-1.378 14.074.158 12.644.295 14.095 1.536 16.305.408.726.741 1.584.741 1.907 0 .323.158.588.351.588.194 0 .575.538.847 1.195s.654 1.096.848.976c.195-.12.354-.01.354.245 0 .781 4.111 4.384 5.003 4.384.328 0 .597.18.597.4 0 .22.36.4.8.4.44 0 .8.18.8.4 0 .22.36.4.8.4.44 0 .8.18.8.4 0 .22.54.4 1.2.4.66 0 1.2.181 1.2.402 0 .268 24.816.4 74.421.396 48.989-.004 74.337-.142 74.176-.402-.143-.233.342-.396 1.179-.396.783 0 1.424-.18 1.424-.4 0-.22.36-.4.8-.4.44 0 .8-.18.8-.4 0-.22.36-.4.8-.4.44 0 .8-.18.8-.4 0-.22.278-.4.617-.4.731 0 1.147-.326 3.988-3.125 1.186-1.168 2.267-2.473 2.403-2.9.135-.426.414-.775.619-.775.205 0 .373-.36.373-.8 0-.44.18-.8.4-.8.22 0 .4-.349.4-.776 0-.427.18-.888.4-1.024.22-.136.4-.741.4-1.344 0-.603.183-1.279.406-1.502.262-.262.368-5 .3-13.376l-.106-12.97-1.2-.216-1.2-.215 1.361-.689c.749-.378 1.604-.688 1.9-.688.297 0 .539-.18.539-.4 0-.22.36-.4.8-.4.44 0 .8-.18.8-.4 0-.22.36-.4.8-.4.44 0 .8-.18.8-.4 0-.22.45-.4 1-.4s1-.18 1-.4c0-.22.27-.4.6-.4.33 0 .6-.18.6-.4 0-.22.36-.4.8-.4.44 0 .8-.18.8-.4 0-.22.36-.4.8-.4.44 0 .801-.135.803-.3.004-.365 1.946-1.3 2.7-1.3.299 0 .433-.18.297-.4-.136-.22.123-.4.576-.4.453 0 .824-.18.824-.4 0-.22.27-.4.6-.4.33 0 .6-.143.6-.318 0-.175.81-.652 1.8-1.06.99-.409 1.8-.86 1.8-1.004 0-.143.897-.701 1.994-1.239 1.096-.539 1.996-1.092 2-1.23.003-.139.546-.476 1.206-.749.66-.273 1.2-.655 1.2-.849 0-.193.242-.351.538-.351.296 0 .864-.36 1.262-.8.398-.44.965-.8 1.259-.8.294 0 1.05-.54 1.681-1.2.631-.66 1.307-1.2 1.503-1.2.641-.001 2.551-1.872 2.25-2.205-.161-.178-.08-.201.181-.051.261.149.928-.182 1.482-.736.554-.555 1.174-1.008 1.378-1.008.203 0 1.111-.72 2.018-1.6.907-.88 1.839-1.6 2.072-1.6.233 0 .312-.18.176-.4-.136-.22.033-.4.376-.4.343 0 .953-.315 1.355-.7.403-.385 1.865-1.69 3.25-2.9 4.979-4.351 16.583-16.209 18.447-18.852 1.235-1.751 1.453-2.017 3.472-4.22.935-1.02 1.7-2.057 1.7-2.303 0-.247.36-.708.8-1.025.44-.317.8-.857.8-1.2 0-.343.36-.883.8-1.2.44-.317.8-.817.8-1.112 0-.294.18-.424.4-.288.22.136.4.006.4-.288 0-.295.36-.795.8-1.112.44-.317.8-.762.801-.988 0-.227.54-1.042 1.199-1.812s1.199-1.625 1.199-1.9c.001-.275.159-.5.352-.5.194 0 .576-.54.849-1.2.273-.66.655-1.2.849-1.2.193 0 .351-.36.351-.8 0-.44.15-.8.332-.8.183 0 .588-.495.9-1.1.313-.605.795-1.34 1.072-1.632.277-.293.401-.698.276-.9-.125-.203-.071-.368.119-.368.372 0 1.701-2.762 1.701-3.534 0-.256.141-.466.314-.466.503 0 1.693-2.256 1.375-2.608-.159-.176-.064-.191.211-.033.309.178.5.05.5-.335 0-.343.18-.624.4-.624.22 0 .4-.36.4-.8 0-.44.18-.8.4-.8.22 0 .4-.36.4-.8 0-.44.18-.8.4-.8.22 0 .4-.36.4-.8 0-.44.18-.8.4-.8.22 0 .4-.36.4-.8 0-.44.18-.8.4-.8.22 0 .4-.349.4-.776 0-.427.18-.888.4-1.024.22-.136.4-.597.4-1.024 0-.427.18-.776.4-.776.22 0 .4-.45.4-1s.18-1 .4-1c.22 0 .4-.27.4-.6 0-.33.18-.6.4-.6.22 0 .4-.45.4-1s.18-1 .4-1c.22 0 .4-.349.4-.776 0-.427.18-.888.4-1.024.22-.136.4-.597.4-1.024 0-.427.18-.776.4-.776.22 0 .4-.362.4-.805 0-.443.173-1.118.385-1.5.693-1.254 3.215-9.102 3.215-10.009 0-.487.18-.886.4-.886.22 0 .4-.54.4-1.2 0-.66.18-1.2.4-1.2.22 0 .4-.72.4-1.6 0-.88.18-1.6.4-1.6.22 0 .4-.529.4-1.176 0-.647.18-1.288.4-1.424.22-.136.4-.867.4-1.624 0-.757.18-1.376.4-1.376.22 0 .4-.72.4-1.6 0-.88.146-1.6.325-1.6.179 0 .369-.855.423-1.9.053-1.045.267-2.071.474-2.28.208-.209.378-1.244.378-2.3 0-1.056.18-1.92.4-1.92.22 0 .4-.9.4-2s.18-2 .4-2c.232 0 .4-1.307.4-3.12 0-1.808.192-3.312.457-3.577.828-.828 1.013-24.975.198-25.791-.36-.36-.655-.803-.655-.984 0-.181-.767-.736-1.704-1.233l-1.704-.904-49.196.205c-27.058.112-64.721.296-83.696.409-23.119.136-34.5.07-34.5-.201s-36.725-.39-111.9-.361l-111.9.044-1.499.856M214 217.595v13.594l13.7.106 13.7.105v27.2l-13.6.2-13.6.2-.2 13.6-.2 13.6-13.7.105c-7.535.058-13.739.058-13.787 0-.047-.058-.182-6.225-.3-13.705L185.8 259l-13.5-.105-13.5-.106V231.2H186v-13.333c0-7.334.12-13.454.267-13.6.146-.147 6.446-.267 14-.267H214v13.595m-33.639 111.583c9.829 1.644 18.266 2.173 26.038 1.631 6.446-.449 8.067-.66 15.401-2.002 5.485-1.004 6.641-1.007 8.582-.016 5.272 2.689 4.539 10.831-1.116 12.406-15.312 4.264-47.835 4.212-59.019-.094-5.549-2.136-6.189-9.471-1.063-12.182 2.216-1.172 2.705-1.161 11.177.257"
                fill="#fbd383"
                />
                <path
                d="M186.267 204.267c-.147.146-.267 6.266-.267 13.6V231.2h-27.2v27.589l13.5.106 13.5.105.213 13.6c.118 7.48.253 13.647.3 13.705.048.058 6.252.058 13.787 0l13.7-.105.2-13.6.2-13.6 13.6-.2 13.6-.2v-27.2l-13.7-.105-13.7-.106V204h-13.733c-7.554 0-13.854.12-14 .267m-17.083 124.654c-5.126 2.711-4.486 10.046 1.063 12.182 11.184 4.306 43.707 4.358 59.019.094 5.655-1.575 6.388-9.717 1.116-12.406-1.941-.991-3.097-.988-8.582.016-7.334 1.342-8.955 1.553-15.401 2.002-7.772.542-16.209.013-26.038-1.631-8.472-1.418-8.961-1.429-11.177-.257"
                fill="#594f4d"
                />
                <path
                d="M228 141.7c0 .374 67.943.346 68.885-.028.377-.15-14.968-.272-34.1-.272s-34.785.135-34.785.3"
                fill="#f4dca4"
                />
            </g>
            </svg>
        </div>
  )
}

export const Tests = () => {
    return(
        <div>
 <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    width="100%"
    height="50vh"
  >
    <path
      d="M256 399.93c40.321 8.707 81.342 36.641 119.064 19.947 38.632-17.096 53.311-63.511 68.474-102.942 15.965-41.517 45.043-91.42 20.542-128.544-25.686-38.919-86.378-24.726-130.883-38.644-26.61-8.322-50.494-18.41-77.197-26.431-40.813-12.26-78.953-43.214-120.298-32.892-47.394 11.831-90.07 46.232-110.63 90.543C3.431 227.602-6.737 290.12 23.88 331.42c30.903 41.687 95.58 29.32 145.35 44.01 29.547 8.721 56.656 17.998 86.77 24.5"
      fill="#7e57c2"
      strokeWidth={0}
    />
    <path
      style={{
        fill: "#c9e3f7",
      }}
      d="M170.667 34.133v392.533C170.667 473.795 208.872 512 256 512s85.333-38.205 85.333-85.333V34.133H170.667z"
    />
    <path
      style={{
        fill: "#d80027",
      }}
      d="M341.333 426.667V301.312c-28.974-11.329-39.84-35.072-85.333-35.072s-56.359 23.743-85.333 35.072v125.355C170.667 473.795 208.872 512 256 512s85.333-38.205 85.333-85.333z"
    />
    <path
      style={{
        fill: "#a2001d",
      }}
      d="M341.333 426.667V301.312c-28.974-11.329-39.84-35.072-85.333-35.072V512c47.128 0 85.333-38.205 85.333-85.333z"
    />
    <path
      style={{
        fill: "#aed5f3",
      }}
      d="M136.533 0h238.933v68.267H136.533z"
    />
    <path
      style={{
        fill: "#93c7ef",
      }}
      d="M256 0h119.467v68.267H256z"
    />
    <circle
      style={{
        fill: "#d80027",
      }}
      cx={238.933}
      cy={187.733}
      r={34.133}
    />
    <circle
      style={{
        fill: "#a2001d",
      }}
      cx={290.133}
      cy={119.467}
      r={17.067}
    />
    <circle
      style={{
        fill: "#d80027",
      }}
      cx={298.667}
      cy={366.933}
      r={25.6}
    />
    <circle
      style={{
        fill: "#a2001d",
      }}
      cx={221.867}
      cy={426.667}
      r={17.067}
    />
  </svg>
        </div>
  )
}

export const MedicinesAndPills = () => {
    return(
        <div>
<svg
    height="50vh"
    width='100%'
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-322.56 -322.56 1157.12 1157.12"
    xmlSpace="preserve"
  >
    <path
      d="M256 624.67c59.17-4.076 117.735 40.497 174.455 23.163 56.578-17.291 79.87-87.238 131.237-116.587 76.49-43.701 235.323-9.277 242.704-97.061 8.58-102.04-187.574-114.864-216.627-213.055C565.9 147.224 707.242 83.427 679.354 11.577 653.894-54.018 532.505-5.77 481.067-53.778c-61.64-57.53-33.606-191.94-111.63-223.902-70.827-29.013-149.371 43.029-207.029 93.365C111.424-139.804 119.04-47.567 62.774-9.953 3.104 29.937-88.61-17.87-147.643 22.957c-56.877 39.335-117.932 114.133-97.915 180.327 24.322 80.433 136.997 93.7 198.194 151.285 32.054 30.162 60.394 65.16 75.69 106.43 25.27 68.193-16.87 169.178 42.18 211.627 52.429 37.69 121.077-43.52 185.494-47.957"
      fill="#3f51b5"
      strokeWidth={0}
    />
    <path
      style={{
        fill: "#c9e3f7",
      }}
      d="M448 448c0 35.2-28.8 64-64 64H128c-35.2 0-64-28.8-64-64V64c0-35.2 28.8-64 64-64h256c35.2 0 64 28.8 64 64v384z"
    />
    <path
      style={{
        fill: "#aed5f3",
      }}
      d="M384 0H256v512h128c35.2 0 64-28.8 64-64V64c0-35.2-28.8-64-64-64z"
    />
    <path
      style={{
        fill: "#fff",
      }}
      d="M240 88c0 17.674-14.326 32-32 32h-64c-17.674 0-32-14.326-32-32s14.326-32 32-32h64c17.674 0 32 14.326 32 32z"
    />
    <path
      style={{
        fill: "#d80027",
      }}
      d="M176 56h-32c-17.674 0-32 14.326-32 32s14.326 32 32 32h32V56z"
    />
    <path
      style={{
        fill: "#fff",
      }}
      d="M400 88c0 17.674-14.326 32-32 32h-64c-17.674 0-32-14.326-32-32s14.326-32 32-32h64c17.674 0 32 14.326 32 32z"
    />
    <path
      style={{
        fill: "#d80027",
      }}
      d="M336 56h-32c-17.674 0-32 14.326-32 32s14.326 32 32 32h32V56z"
    />
    <path
      style={{
        fill: "#fff",
      }}
      d="M240 200c0 17.674-14.326 32-32 32h-64c-17.674 0-32-14.326-32-32s14.326-32 32-32h64c17.674 0 32 14.326 32 32z"
    />
    <path
      style={{
        fill: "#d80027",
      }}
      d="M176 168h-32c-17.674 0-32 14.326-32 32s14.326 32 32 32h32v-64z"
    />
    <path
      style={{
        fill: "#fff",
      }}
      d="M400 200c0 17.674-14.326 32-32 32h-64c-17.674 0-32-14.326-32-32s14.326-32 32-32h64c17.674 0 32 14.326 32 32z"
    />
    <path
      style={{
        fill: "#d80027",
      }}
      d="M336 168h-32c-17.674 0-32 14.326-32 32s14.326 32 32 32h32v-64z"
    />
    <path
      style={{
        fill: "#fff",
      }}
      d="M240 312c0 17.674-14.326 32-32 32h-64c-17.674 0-32-14.326-32-32s14.326-32 32-32h64c17.674 0 32 14.326 32 32z"
    />
    <path
      style={{
        fill: "#d80027",
      }}
      d="M176 280h-32c-17.674 0-32 14.326-32 32s14.326 32 32 32h32v-64z"
    />
    <path
      style={{
        fill: "#fff",
      }}
      d="M400 312c0 17.674-14.326 32-32 32h-64c-17.674 0-32-14.326-32-32s14.326-32 32-32h64c17.674 0 32 14.326 32 32z"
    />
    <path
      style={{
        fill: "#d80027",
      }}
      d="M336 280h-32c-17.674 0-32 14.326-32 32s14.326 32 32 32h32v-64z"
    />
    <path
      style={{
        fill: "#fff",
      }}
      d="M240 424c0 17.674-14.326 32-32 32h-64c-17.674 0-32-14.326-32-32s14.326-32 32-32h64c17.674 0 32 14.326 32 32z"
    />
    <path
      style={{
        fill: "#d80027",
      }}
      d="M176 392h-32c-17.674 0-32 14.326-32 32s14.326 32 32 32h32v-64z"
    />
    <path
      style={{
        fill: "#fff",
      }}
      d="M400 424c0 17.674-14.326 32-32 32h-64c-17.674 0-32-14.326-32-32s14.326-32 32-32h64c17.674 0 32 14.326 32 32z"
    />
    <path
      style={{
        fill: "#d80027",
      }}
      d="M336 392h-32c-17.674 0-32 14.326-32 32s14.326 32 32 32h32v-64z"
    />
  </svg>
        </div>
  )
}

export const Logo = () => {
  return(
    <div>
    <svg     
    height="auto"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="70 70 500 500"
    xmlSpace="preserve">
    <g className="currentLayer">
      <g fill="none" strokeWidth={2}>
        <path
          stroke="#656478"
          d="M359.85 180A39.85 39.85 0 0 0 320 140.15 39.85 39.85 0 0 0 280.15 180 39.85 39.85 0 0 0 320 219.85 39.85 39.85 0 0 0 359.85 180"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#5b5b6f"
          d="m280.11 320.08-.08 39.9"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#838296"
          d="M280.03 359.98q-10.12.04-19.53.22-28.48.56-45.73 20.59-6.67 7.75-10.44 16.95-6.59 16.07-3.27 33.45 4.33 22.65 23.38 37.12 16.14 12.27 38.31 11.69 4.75-.12 17.47.08"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#5b5b6f"
          d="m280.22 480.08-.17 19.37a.52.49 0 0 0 .52.49h78.86a.52.5-.5 0 0 .52-.51l-.15-19.4"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#838296"
          d="m359.8 480.03 79.19-.03q1.01 0 .17-.56L381.3 440.8a5.15 4.79-26.3 0 0-2.72-.81l-18.76-.1"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#5b5b6f"
          d="m359.82 439.89.22-39.89"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#838296"
          d="M360.04 400q8.61 0 17.21.04 29.93.14 47.97-20.83 6.73-7.83 10.42-16.97 5.17-12.78 4.12-26.62-.77-10.11-4.74-19.32-7.06-16.41-22.7-26.56-13.13-8.53-26.57-9.49-5.67-.4-25.97-.31"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#5b5b6f"
          d="m359.78 279.94.19-19.09a.86.84.3 0 0-.86-.85l-78.56.06a.5.49-.6 0 0-.5.5l.17 19.34"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#838296"
          d="M280.22 279.9q-8.85.3-17.75.02-7.24-.22-11.03-1.98-5.71-2.65-8.77-8.13-2.87-5.13-2.56-11.03.32-6.22 4.17-11.1 3.05-3.85 7.32-5.77 4.25-1.92 9.4-1.91 29.22.05 58.04-.06.76 0 .13-.43l-58.48-38.97a3.44 3.41-29.6 0 0-2.07-.56q-21.23 1.11-36.58 13.68-7.77 6.35-13.14 14.95-9.06 14.5-8.9 31.64.2 21.67 13.73 37.87 6.49 7.78 15.01 13.1 11.98 7.48 25.51 8.53 5.05.39 25.86.33"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#d8d8d8"
          d="m280.22 279.9 79.56.04M360.04 400v-40"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#838296"
          d="M360.04 360q9.63.15 19.26-.13 4.65-.13 7.27-1.04 3.72-1.28 6.49-3.77 6.24-5.59 6.78-13.28.52-7.28-3.72-13.36-5.88-8.44-18.12-8.42-13.92.02-18.18.12"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#d8d8d8"
          d="m359.82 320.12-79.71-.04"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#5b5b6f"
          d="m359.82 320.12.22 39.88"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#d8d8d8"
          d="m359.82 439.89-79.63-.01"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#5b5b6f"
          d="m280.19 439.88-.18-39.82"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#d8d8d8"
          d="m280.01 400.06.02-40.08"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#838296"
          d="M280.01 400.06q-19.51-.45-23.01.19-5.98 1.1-9.69 4.31-8.57 7.43-7.11 17.82.92 6.51 5.24 11.16 4.63 4.98 11.51 6.14 2.12.36 11.61.35 5.86-.01 11.63-.15"
          vectorEffect="non-scaling-stroke"
        />
        <path
          stroke="#d8d8d8"
          d="m359.8 480.03-79.58.05"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <path
        fill="#06052d"
        d="M532.43 339.99a212.44 212.44 0 0 1-212.44 212.44 212.44 212.44 0 0 1-212.44-212.44 212.44 212.44 0 0 1 212.44-212.44 212.44 212.44 0 0 1 212.44 212.44ZM359.85 180A39.85 39.85 0 0 0 320 140.15 39.85 39.85 0 0 0 280.15 180 39.85 39.85 0 0 0 320 219.85 39.85 39.85 0 0 0 359.85 180Zm-79.74 140.08-.08 39.9q-10.12.04-19.53.22-28.48.56-45.73 20.59-6.67 7.75-10.44 16.95-6.59 16.07-3.27 33.45 4.33 22.65 23.38 37.12 16.14 12.27 38.31 11.69 4.75-.12 17.47.08l-.17 19.37a.52.49 0 0 0 .52.49h78.86a.52.5-.5 0 0 .52-.51l-.15-19.4 79.19-.03q1.01 0 .17-.56L381.3 440.8a5.15 4.79-26.3 0 0-2.72-.81l-18.76-.1.22-39.89q8.61 0 17.21.04 29.93.14 47.97-20.83 6.73-7.83 10.42-16.97 5.17-12.78 4.12-26.62-.77-10.11-4.74-19.32-7.06-16.41-22.7-26.56-13.13-8.53-26.57-9.49-5.67-.4-25.97-.31l.19-19.09a.86.84.3 0 0-.86-.85l-78.56.06a.5.49-.6 0 0-.5.5l.17 19.34q-8.85.3-17.75.02-7.24-.22-11.03-1.98-5.71-2.65-8.77-8.13-2.87-5.13-2.56-11.03.32-6.22 4.17-11.1 3.05-3.85 7.32-5.77 4.25-1.92 9.4-1.91 29.22.05 58.04-.06.76 0 .13-.43l-58.48-38.97a3.44 3.41-29.6 0 0-2.07-.56q-21.23 1.11-36.58 13.68-7.77 6.35-13.14 14.95-9.06 14.5-8.9 31.64.2 21.67 13.73 37.87 6.49 7.78 15.01 13.1 11.98 7.48 25.51 8.53 5.05.39 25.86.33Z"
      />
      <path
        fill="#fff"
        d="M359.85 180A39.85 39.85 0 0 1 320 219.85 39.85 39.85 0 0 1 280.15 180 39.85 39.85 0 0 1 320 140.15 39.85 39.85 0 0 1 359.85 180ZM280.22 279.9l79.56.04q20.3-.09 25.97.31 13.44.96 26.57 9.49 15.64 10.15 22.7 26.56 3.97 9.21 4.74 19.32 1.05 13.84-4.12 26.62-3.69 9.14-10.42 16.97-18.04 20.97-47.97 20.83-8.6-.04-17.21-.04v-40q9.63.15 19.26-.13 4.65-.13 7.27-1.04 3.72-1.28 6.49-3.77 6.24-5.59 6.78-13.28.52-7.28-3.72-13.36-5.88-8.44-18.12-8.42-13.92.02-18.18.12l-79.71-.04q-20.81.06-25.86-.33-13.53-1.05-25.51-8.53-8.52-5.32-15.01-13.1-13.53-16.2-13.73-37.87-.16-17.14 8.9-31.64 5.37-8.6 13.14-14.95 15.35-12.57 36.58-13.68a3.44 3.41-29.6 0 1 2.07.56l58.48 38.97q.63.43-.13.43-28.82.11-58.04.06-5.15-.01-9.4 1.91-4.27 1.92-7.32 5.77-3.85 4.88-4.17 11.1-.31 5.9 2.56 11.03 3.06 5.48 8.77 8.13 3.79 1.76 11.03 1.98 8.9.28 17.75-.02Z"
      />
      <path
        fill="#fff"
        d="m359.78 279.94-79.56-.04-.17-19.34a.5.49-.6 0 1 .5-.5l78.56-.06a.86.84.3 0 1 .86.85l-.19 19.09ZM359.82 320.12l.22 39.88v40l-.22 39.89-79.63-.01-.18-39.82.02-40.08.08-39.9 79.71.04Z"
      />
      <path
        fill="#06052d"
        d="m360.04 360-.22-39.88q4.26-.1 18.18-.12 12.24-.02 18.12 8.42 4.24 6.08 3.72 13.36-.54 7.69-6.78 13.28-2.77 2.49-6.49 3.77-2.62.91-7.27 1.04-9.63.28-19.26.13Z"
      />
      <path
        fill="#fff"
        d="m280.03 359.98-.02 40.08q-19.51-.45-23.01.19-5.98 1.1-9.69 4.31-8.57 7.43-7.11 17.82.92 6.51 5.24 11.16 4.63 4.98 11.51 6.14 2.12.36 11.61.35 5.86-.01 11.63-.15l79.63.01 18.76.1a5.15 4.79-26.3 0 1 2.72.81l57.86 38.64q.84.56-.17.56l-79.19.03-79.58.05q-12.72-.2-17.47-.08-22.17.58-38.31-11.69-19.05-14.47-23.38-37.12-3.32-17.38 3.27-33.45 3.77-9.2 10.44-16.95 17.25-20.03 45.73-20.59 9.41-.18 19.53-.22Z"
      />
      <path
        fill="#06052d"
        d="m280.01 400.06.18 39.82q-5.77.14-11.63.15-9.49.01-11.61-.35-6.88-1.16-11.51-6.14-4.32-4.65-5.24-11.16-1.46-10.39 7.11-17.82 3.71-3.21 9.69-4.31 3.5-.64 23.01-.19Z"
      />
      <path
        fill="#fff"
        d="m359.8 480.03.15 19.4a.52.5-.5 0 1-.52.51h-78.86a.52.49 0 0 1-.52-.49l.17-19.37 79.58-.05Z"
      />
    </g>
  </svg>
      </div>
)
}